import { CatNutritionSegmentationIds, NutritionSegmentationIds } from 'constants/segmentation';
import { SmartCollectionInput, SmartCollectionItem, SmartCollectionResponse } from '../types';
import { InputProductType } from 'interfaces/api-input/input-product-type';

/**
 * Type guard for SmartCollectionResponse
 */
export function isSmartCollectionResponse(input: unknown): input is SmartCollectionResponse {
  return (
    input !== null && typeof input === 'object' && 'items' in input && Array.isArray(input.items)
  );
}

/**
 * Type guard for SmartCollectionResponse
 */
export function isSmartCollectionItem(input: unknown): input is SmartCollectionItem {
  return (
    input !== null &&
    typeof input === 'object' &&
    'product_title' in input &&
    typeof input.product_title === 'string'
  );
}

/**
 * List of excluded needs to filter them out from smart collection requests
 * Currently, we do not exclude any needs, but we keep the list here for future use
 */
const SMART_COLLECTION_EXCLUDED_NEEDS: ReadonlyArray<
  NutritionSegmentationIds | CatNutritionSegmentationIds
> = [];

/**
 * Clean up the input for the smart collection request
 * Modifies food types with FoodSupplement food type in case there is at least one food type has been provided
 * @param input - The input for the smart collection request
 * @returns The cleaned up input
 */
export function cleanUpInput(input: SmartCollectionInput): SmartCollectionInput {
  const modifiedInput = { ...input };

  // food supplement injection in case there are food types selected
  if (
    Array.isArray(input.food_types) &&
    input.food_types.length > 0 &&
    !input.food_types.includes(InputProductType.FoodSupplement)
  ) {
    modifiedInput['food_types'] = [...input['food_types'], InputProductType.FoodSupplement];
  }

  return {
    ...modifiedInput,
    ...(modifiedInput.needs
      ? {
          needs: modifiedInput.needs.filter(
            (need) => !SMART_COLLECTION_EXCLUDED_NEEDS.includes(need)
          ),
        }
      : {}),
  };
}
